import { gql } from '@lcs/shared/api';

export const getBannedProvisioningIpsQuery = gql`
   query GetBannedProvisioningIps($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      unfilteredBlockedIpAddressesConnection: blockedIpAddressesConnection(first: 1) {
         totalCount
      }
      blockedIpAddressesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            blockedIpAddressId
            ipAddress
            type
            firstSeen
            updateDate
            status
            statusName
         }
      }
   }
`;
